module.exports = __webpack_public_path__ + "static/media/13B.5d1a0050.png";